import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDPagination from "components/MDPagination";

// Page numbers displayed around the current page
const getPages = (currentPage, totalPages, window = 2) => {
	const start = Math.max(1, currentPage - window);
	const end = Math.min(totalPages, currentPage + window);
	return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

/**
 * MUI v5 replacement of react-pagination-js (1-based pages).
 */
export default function PagePagination({
	currentPage,
	totalPages,
	changeCurrentPage,
	color = "primary"
}) {
	if (!totalPages || totalPages <= 1) {
		return null;
	}
	return (
		<MDPagination variant="gradient" color={color}>
			{currentPage > 1 && (
				<MDPagination item onClick={() => changeCurrentPage(currentPage - 1)}>
					<Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
				</MDPagination>
			)}
			{getPages(currentPage, totalPages).map(page => (
				<MDPagination
					item
					key={page}
					active={page === currentPage}
					onClick={() => changeCurrentPage(page)}
				>
					{page}
				</MDPagination>
			))}
			{currentPage < totalPages && (
				<MDPagination item onClick={() => changeCurrentPage(currentPage + 1)}>
					<Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
				</MDPagination>
			)}
		</MDPagination>
	);
}

PagePagination.propTypes = {
	currentPage: PropTypes.number.isRequired,
	totalPages: PropTypes.number,
	changeCurrentPage: PropTypes.func.isRequired,
	color: PropTypes.string
};
